import {
  Box,
  MenuItem,
  Select,
  type SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material'
import { colorPrimitives } from './Theme'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { pluralize } from 'utils/util'

export const WeekRangeSelect = ({
  label,
  numDays,
  displayWeeks,
  setNumDays,
  setStartDate,
  dateOffset,
  children,
}: {
  label?: string
  setNumDays: (days: string) => void
  setStartDate: (startDate: Date) => void
  dateOffset?: (date: number) => Date
  numDays: string
  displayWeeks: number[]
  children: React.ReactNode
}) => {
  const handleChange = (e: SelectChangeEvent) => {
    const days = -Number(e.target.value)
    setNumDays(e.target.value)
    if (dateOffset) {
      setStartDate(dateOffset(days))
    }
  }

  return (
    <Stack spacing={'24px'}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          width: '100%',
          justifyContent: { xs: 'start', sm: 'space-between' },
          alignItems: { xs: 'start', sm: 'center' },
          rowGap: '8px',
        }}
      >
        <Box>
          <Typography variant="h3">{label}</Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            'svg path': {
              fill: colorPrimitives.redGaming,
            },
          }}
        >
          <Select
            value={numDays}
            onChange={handleChange}
            displayEmpty
            sx={{
              padding: '0px 0px 0px 0px !important',
              boxShadow: 'none',
              '.MuiOutlinedInput-notchedOutline': {
                border: 'none !important',
              },
              '.Mui-focused': { border: 'none !important' },
              color: colorPrimitives.redGaming,
            }}
            IconComponent={KeyboardArrowDownIcon}
          >
            {displayWeeks.map((dw) => {
              return (
                <MenuItem key={dw * 7} value={dw * 7}>
                  Last {pluralize(dw, 'Week')}
                </MenuItem>
              )
            })}
          </Select>
        </Box>
      </Box>

      {children}
    </Stack>
  )
}
